module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "users"
    }
  }, [_c('v-panel', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.error), function(err) {
    return (_vm.error && typeof(_vm.error) == 'object') ? _c('div', {
      staticClass: "alert alert-danger alert-dismissable"
    }, [_vm._v("\n          " + _vm._s(err[0]) + "\n        ")]) : _vm._e()
  }), _vm._v(" "), (_vm.error && typeof(_vm.error) == 'string') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_vm._v(_vm._s(_vm.success))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "back-to-list",
    attrs: {
      "href": "#/users"
    }
  }, [_c('i', {
    staticClass: "icon md-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t("account.users.detail.back_to_list")))]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "role": "form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        !_vm.user.id ? _vm.save_user(_vm.user) : _vm.edit_user(_vm.user)
      }
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(!_vm.user.id) ? _c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t("account.users.detail.title")) + " ")]) : _vm._e(), _vm._v(" "), (_vm.user.id) ? _c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.user.full_name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-actions"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))]), _vm._v(" "), (_vm.user.id) ? _c('button', {
    staticClass: "btn btn-default waves-effect waves-classic",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.delete_user(_vm.user.id)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("button.delete")) + " ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("account.users.detail.avatar")))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    staticClass: "avatar-wrapper text-center"
  }, [(_vm.user.avatar) ? _c('img', {
    staticClass: "img-rounder",
    attrs: {
      "src": _vm.user.avatar ? _vm.user.avatar : '',
      "alt": "",
      "width": "100",
      "height": "100"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('input', {
    staticClass: "img-rounder",
    attrs: {
      "type": "file",
      "id": 'input-file-now-custom-' + _vm.user.id,
      "data-plugin": "dropify",
      "data-default-file": "",
      "width": "100",
      "height": "100"
    },
    on: {
      "change": _vm.onAvatarChange
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("account.users.detail.information")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "first-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.full_name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.full_name),
      expression: "user.full_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "first-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "full_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.phone")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "description"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.description")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.description),
      expression: "user.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "description",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.user.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change_password),
      expression: "change_password"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.change_password) ? _vm._i(_vm.change_password, null) > -1 : (_vm.change_password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.change_password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.change_password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.change_password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.change_password = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.users.change_password")))])])]) : _vm._e(), _vm._v(" "), ((_vm.user.id && _vm.change_password) || !_vm.user.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.password")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password2"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.confirm_password")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password_confirmation),
      expression: "user.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password2",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password_confirmation", $event.target.value)
      }
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("account.users.detail.status_role")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "status"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.users.status")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.active),
      expression: "user.active"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "status",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.users.active")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.users.inactive")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "role"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.role")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role_id),
      expression: "user.role_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "role",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Administrator")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Manager")])])])])])])])])])])])], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b261032"}!./src/app/pages/users/detail/detail.html
// module id = 1380
// module chunks = 0